export default __webpack_public_path__ + "static/media/flag-fr-BE.712d5b8e.png";